<template>
    <section class="cooperation">
        <h1 class="hide">회의/협의체 홈</h1>
        
        <CooperationHeader 
          ref='cooperationHeader'  
          @noneReadCooperation="noneReadCooperation"/> 
        <div class="tab_ty1" id="tabs">
          <div class="tab-menu">
            <div class="inner">
              <ul>
                  <li  v-for="(tab, index) in categoryListTabs" v-bind:class="{active:currentTab===tab.index}" :key="'category_'+index">
                      <button type="button" v-on:click="selectTab(tab)" class="ell-singleline">{{tab.name}}</button>
                      <div class="tooltip-b tl small" v-if="$tooltip.checkTabLength(tab.name, 24)">{{tab.name}}</div>
                  </li>
              </ul>
              <div class="dropdown ty1 right" v-if="categoryListSelectBox.length != 0">
                  <v-menu offset-y>
                      <template v-slot:activator="{ on, attrs }">
                          <v-btn v-bind="attrs" v-on="on">{{ $i18nUtil.trans("message.Cooperation.002","전체보기") }}({{categoryListSelectBox.length}})</v-btn>
                      </template>
                      <div class="dropdown-list">
                          <dl>
                              <dt>{{ $i18nUtil.trans("message.Cooperation.003","전체 카테고리") }} ({{categoryListSelectBox.length}})</dt>
                              <dd>
                                  <ul class="scroll" style="height: 490px;">
                                      <li v-for="(tab , index ) in categoryListSelectBox" :key="'selectBoxCategory_'+index">
                                          <button type="button" class="ell-singleline" @click="selectTab(tab)">{{tab.name}}</button>
                                          <div class="tooltip-b tl small" v-if="$tooltip.checkTabLength(tab.name, 24)">{{tab.name}}</div>
                                      </li> 
                                  </ul>
                              </dd>
                          </dl>
                      </div>
                  </v-menu>
              </div>
            </div> 
          </div>
            <!-- <div class="tab-menu" > 
                <ul class="tab-menu">
                    <li v-for="(tab, index) in categoryListTabs" v-bind:class="{active:currentTab===index}" :key="'cooperationCategory_'+index">
                        <button type="button" v-on:click=" selectTab(index)">{{tab}}</button>
                    </li>
                </ul>
            </div> -->

            <!-- 회의/협의체 메인 > 탭(카테고리) 구성 -->
            <div class="tab-content">
                <CooperationAll
                  v-if="currentTab == 0"
                  :categoryList="categoryList"
                  :myUserId="myUserId" 
                  :headerNoneRead="headerNoneRead"
                  @moveCategoryMore="moveCategoryMore"
                ></CooperationAll>
                <!-- <template v-for="(category, index) in categoryList"  ></template> --><!-- :key="'category_' + index" -->
                <!-- <template v-for="(category, index) in categoryList">  
                  <CooperationContents
                    :ref="'cooperationContents'+(index + 1)" 
                    :key="'category_' + index"
                    v-show="currentTab == index + 1"
                    :category="category"
                    :myUserId="myUserId"  
                  ></CooperationContents> 
                </template> -->
                <CooperationContents 
                    v-if="currentTab > 0"
                    :category="category" 
                    :myUserId="myUserId"  
                    :headerNoneRead="headerNoneRead"
                  ></CooperationContents>
              </div>
        </div> 
        <modals-container 
          @board_Regist="addboard"
        ></modals-container>
    </section>
</template>

<script>
import CooperationAll from "./CooperationAll";
import CooperationHeader from "./CooperationHeader";
import CooperationContents from "./CooperationContents";
import { mapState, mapActions, mapMutations } from "vuex";

import Vue from 'vue'
import VueAwesomeSwiper from 'vue-awesome-swiper'
Vue.use(VueAwesomeSwiper, /* { default global options } */)
// Navigation error로 아래 내용으로 대체
import {Swiper as SwiperClass, Scrollbar, Navigation} from 'swiper/swiper.esm.js'
import getAwesomeSwiper from 'vue-awesome-swiper/dist/exporter'
// Swiper modules
SwiperClass.use([Scrollbar, Navigation])
// local component
const {directive} = getAwesomeSwiper(SwiperClass)
// let loadView = true;
export default {
  name: 'tabs',
  directives: {
    swiper: directive
  },
  components: {
    CooperationAll,
    CooperationHeader,
    CooperationContents
  },
  data() {
    return { 

      myUserId:"",
      /* 현재 탭(최초 전체 탭 : 0) */
      currentTab: -1,
      /* 카테고리 탭 리스트 */
      categoryListTabs: [],
      categoryListSelectBox : [],
      /* 카테고리 리스트 */
      categoryList: [],
      boardListCount: [],   

      category:[],

      //카테고리 필터 정보 

      toastInfo: {
          obj: this.$toasted,
          message: "",
          options: {
              theme: "toasted-primary",
              position: "bottom-left",
              duration: 3000,
          },
      },

      headerNoneRead:false,
           
    };
  },
  created(){
    
    /* 카테고리 리스트 조회 */
    this.getCfrcCategoryList();  
    
    // 회의협의체 관리자 인지 판단 .
    // 회의협의체 카테고리 관리 버튼 항상 노출로 불필요한 함수. : 0312
    // this.getCooperationManageYn();

    this.setCfrcNoneReadCount(-1); 
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper
    }
  },
  mounted() {
    // 뒤로가기 이벤트 발생시 .
    const self = this;
    window.onpopstate = function (event) {
      // 호출|알림 팝업 띄우기위한 값.
      self.setEventBackYn(true);
      let returnUrls = localStorage.getItem("returnUrls");
      if(returnUrls != null) {
        let urlList = returnUrls.split(",");
        if (urlList.length > 0) {
          if (urlList.length == 1) {
            localStorage.removeItem("returnUrls");
            // self.$router.push("/general/home");
          } else {
            urlList.pop();
            urlList.pop();
            localStorage.setItem("returnUrls", urlList);
            // this.$router.replace(urlList[urlList.length-1]);
          }
        } else {
          self.$router.push("/general/home");
        }
      }else{
          self.$router.push("/general/home");
      }
    }
  },
  methods: {
    ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
    ...mapActions("modals", ["showToast", "showModal"]), 
    ...mapMutations("shareInfo", ["setCfrcNoneReadCount"]),
    ...mapActions("noti", ["setEventBackYn"]),
    // ...mapMutations("shareInfo", ["setCooperationManageYn"]),
    // ...mapMutations("shareInfo", ["setCooperationManageCountYn"]),
    //회의협의체 관리자 인지 판단 
    // getCooperationManageYn(){
    //   let obj = this; 
    //   let reqData = {};
    //   reqData.params = {}
    //   reqData.req = obj.req;
    //   reqData.url = "/api/copaper/cooperation/getCfrcCategoryManagerYn";
    //   reqData.method = "post";
    //   obj
    //   .COWORK_REST_SIMPLE_ACTION(reqData)
    //   .then(function(res) {
    //       if (res.errorCode == null) {
    //         if (res.result == null) {
    //           let cooperationManageYn = false;
    //           obj.checkMyManageCategory();
    //           obj.setCooperationManageYn(cooperationManageYn);
    //         } else {
    //           let cooperationManageYn = true;
    //           obj.setCooperationManageYn(cooperationManageYn);
    //         }
    //       } else {
    //         console.log(res); 
    //       }
    //   })
    //   .catch(function(err) {
    //       console.log(err);
    //   });
    // },
    //관리자가 아닐 때 관리하는 카테고리가 있는지 확인.
    // checkMyManageCategory(){
    //   let obj = this; 
    //   let reqData = {};
    //   reqData.params = {}
    //   reqData.req = obj.req;
    //   reqData.url = "/api/copaper/cooperation/getMyCooperationManageCount";
    //   reqData.method = "post";
    //   obj
    //   .COWORK_REST_SIMPLE_ACTION(reqData)
    //   .then(function(res) {
    //       if (res.errorCode != null) {
    //         console.log(res)
    //       } else {
    //         if (res.result == 0) {
    //           let cooperationManageCountYn = false; 
    //           obj.setCooperationManageCountYn(cooperationManageCountYn);
    //         } else {
    //           let cooperationManageCountYn = true;
    //           obj.setCooperationManageCountYn(cooperationManageCountYn);
    //         }
    //       }
    //   })
    //   .catch(function(err) {
    //       console.log(err);
    //   });
    // },
    /* 카테고리 리스트 & 카테고리별 보드 개수 조회 */
    getCfrcCategoryList() {
 
      let obj = this;
      let reqData = { 
        url: "/api/copaper/cooperation/getCfrcCategoryListByUserIdIncludeNormal", 
        method: "post"
      };
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then(function(res) {  
          obj.myUserId= res.result.userId; 
          let list = res.result.categoryList; 
          /* 카테고리 탭 목록에 추가 */
          // list.forEach(element => {
          //   obj.categoryListTabs.push(element.categoryName); 
          // }); 
          // for (let i = 0; i < 3; i++) { 
          //   obj.categoryListTabs.push(list[i].categoryName);
          // }
          obj.categoryListTabs.push({name: obj.$i18nUtil.trans("message.Cooperation.001","전체"), index:0})
          for(let k in list){
            if(k < 4){
              let data = {
                categoryMid : list[k].categoryMid,
                name : list[k].categoryName,
                index : (k*1)+1
              }
              obj.categoryListTabs.push(data);
            } 
            
            let data = {
              categoryMid : list[k].categoryMid,
              name : list[k].categoryName,
              index : (k*1)+1
            }
            obj.categoryListSelectBox.push(data);
             
          }
          obj.categoryList = list;  

          let localState = JSON.parse(window.sessionStorage.getItem("cooperation"));
          if(localState != null){
            obj.$nextTick(function(){
              obj.categoryListSelectBox.filter(function(category){
                if(category.categoryMid == localState.categoryMid){
                  obj.currentTab = category.index;
                  obj.selectTab(category); 
                }
              })
              //카테고리홈 재접속시 탭선택되는것을 막기위해 제거.
              window.sessionStorage.removeItem("cooperation");
            })
          } else{
            // 일반적인 홈 접근시 .
            obj.currentTab = 0;
          }
        })
        .catch(function(err) {
          console.log(err);
        });
    },
    addboard(_data){ 
      let obj = this;
      let reqData = {};
      reqData.params ={
        paperTitle : _data.boardName, 
        paperId: _data.paperId,  
        groupId : _data.category.groupId, 
        categoryMid : _data.category.categoryMid,  
        contentPath : _data.contentPath, 
        docGrade: _data.docGrade,
        blockType: "CONTENT",
        siteId:_data.category.sharePointSiteId,
        folderId:_data.category.sharePoinFolderId,
        link:"/general/board/" + _data.paperId,
        tagList: _data.tagList
      }
      reqData.req = obj.req;
      reqData.url = "/api/copaper/paper/addPaper";
      reqData.method = "post";
 
      //프로그레스바 시작 
      this.showLoadingbar();
      obj
      .COWORK_REST_SIMPLE_ACTION(reqData)
      .then(res => {  
        //프로그레스바 종료
        this.hideLoadingbar(); 
        //let newBoard = JSON.parse(res.config.data)
                    //newBoard = newBoard.paperId
        if(res.errorCode != null){
            return;
        }else{    
          let state = {
            categoryName : _data.category.categoryName,
            categoryMid : _data.category.categoryMid
          }
          window.sessionStorage.setItem("cooperation",JSON.stringify(state));
          this.toastInfo.message = this.$i18nUtil.trans("TB036");// "보드가 저장되었습니다.";
          this.showToast(this.toastInfo);
          let newBoard = res.result;
          this.$router.push('/general/board/'+newBoard);
        }       
      })
      .catch(function(err) {
        console.log(err);
      });

    },  
    selectTab(tab){
      if(this.currentTab != tab.index){
        this.setCfrcNoneReadCount(-1); 
      } 
      this.currentTab = tab.index;
      if(tab.index != 0){  
        this.category = this.categoryList[tab.index-1];
        this.$refs.cooperationHeader.setType("TAB"); 

        if(tab.index >= 4){
          let moveTab = this.categoryListTabs.pop();  
          this.categoryListTabs.push(tab); 
        }
      }else{  
        this.categoryList.push(); 
        this.$refs.cooperationHeader.setType("ALL");  
      }

      //localstorage
      // localStorage.setItem("cooperation",JSON.stringify(tab));
    },
    noneReadCooperation(){ 
      if(this.currentTab != 0){
        this.headerNoneRead = !this.headerNoneRead;
      }else{
        this.headerNoneRead = !this.headerNoneRead; 
      }
    }, 
    moveCategoryMore(_categoryInfo){
      let selectedCategoryIndex = 0;
      for(let k in this.categoryList){
          if(this.categoryList[k].categoryMid == _categoryInfo.categoryMid){ 
              selectedCategoryIndex = (k*1)+1;
          }
      } 
      let data = {
          index : selectedCategoryIndex,
          name : _categoryInfo.categoryName
      } 
      this.currentTab = selectedCategoryIndex;
      this.selectTab(data); 
    }
  }
};
</script>

<style scoped>
.cooperation .tab_ty1 > .tab-menu .inner > ul > li > button + .tooltip-b, .cooperation .tab_ty1 > .tab-menu .inner > ul > li > button + .tooltip-b {
    max-width: 500px;
}
</style>



// WEBPACK FOOTER //
// src/components/cowork/general/cooperation/base/Cooperation.vue